function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import Chevron from "../../../icon-components/chevron";
import CountryItem from "../country-item/country-item";

var ContinentItem =
/*#__PURE__*/
function (_Component) {
  _inherits(ContinentItem, _Component);

  function ContinentItem(props) {
    var _this;

    _classCallCheck(this, ContinentItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContinentItem).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleCollapse", function () {
      var isCollapsed = _this.state.isCollapsed;

      _this.setState({
        isCollapsed: !isCollapsed
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleContinentSelect", function () {
      var _this$props = _this.props,
          onCountrySelect = _this$props.onCountrySelect,
          name = _this$props.name;
      onCountrySelect(null, null, null, name);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleCountrySelect", function (territoryId) {
      return function () {
        var onCountrySelect = _this.props.onCountrySelect;
        onCountrySelect(territoryId);
      };
    });

    _this.state = {
      isCollapsed: true
    };
    return _this;
  }

  _createClass(ContinentItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var expandAll = _ref.expandAll;
      var isCollapsed = this.state.isCollapsed;
      this.setState({
        isCollapsed: isCollapsed && !expandAll
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          name = _this$props2.name,
          countries = _this$props2.countries,
          territoryIdKey = _this$props2.territoryIdKey,
          territoryNameKey = _this$props2.territoryNameKey;
      var isCollapsed = this.state.isCollapsed;
      var isWholeGroupSelected = countries.filter(function (_ref2) {
        var isDisabled = _ref2.isDisabled;
        return !isDisabled;
      }).every(function (_ref3) {
        var isSelected = _ref3.isSelected;
        return isSelected;
      });
      var isWholeGroupDisabled = countries.every(function (_ref4) {
        var isDisabled = _ref4.isDisabled;
        return isDisabled;
      });
      var continentClasses = cx('ContinentItem-label', {
        'ContinentItem-label-inverted': !isCollapsed,
        'ContinentItem-fullWidth': true
      });
      var continentContainerClasses = cx({
        checkbox: true,
        'ContinentItem-bordered': !isCollapsed,
        'ContinentItem-container': true
      });
      return React.createElement("div", {
        className: "ContinentItem"
      }, React.createElement("div", {
        className: continentContainerClasses
      }, React.createElement(CountryItem, {
        isSelected: isWholeGroupSelected,
        territoryName: "".concat(name, " (").concat(countries.length, ")"),
        isDisabled: isWholeGroupDisabled,
        onHandleSelect: this.handleContinentSelect
      }), React.createElement("span", {
        className: continentClasses,
        onClick: this.handleCollapse
      }, React.createElement(Chevron, null))), isCollapsed ? null : countries.map(function (_ref5, i) {
        var id = _ref5[territoryIdKey],
            isSelected = _ref5.isSelected,
            isDisabled = _ref5.isDisabled,
            territoryName = _ref5[territoryNameKey];
        return React.createElement("div", {
          key: i,
          className: "checkbox ContinentItem-container ContinentItem-country"
        }, React.createElement(CountryItem, {
          isSelected: isSelected,
          isDisabled: isDisabled,
          territoryName: territoryName,
          onHandleSelect: _this2._handleCountrySelect(id)
        }));
      }));
    }
  }]);

  return ContinentItem;
}(Component);

_defineProperty(ContinentItem, "propTypes", {
  onCountrySelect: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  countries: PropTypes.array.isRequired,
  expandAll: PropTypes.bool,
  territoryIdKey: PropTypes.string,
  territoryNameKey: PropTypes.string
});

export default ContinentItem;